import { getExpressionFields } from 'apps/web_forms/expressions/expressions';
import { expressionNames } from 'apps/web_forms/utils/constants';

/**
 * Return true if any item in the array is truthy, false otherwise
 * @param {Array} array
 * @returns {boolean}
 */
export const any = (array) => array.some(elem => elem);

const mergeIndexes = (field, depthArray) => {
  let identifier = field.identifier
  if(identifier.includes("/")){
    let splitIdentifier = identifier.split("/")
    if(splitIdentifier.length < depthArray.length){
      depthArray.length = splitIdentifier.length
    }
    let cloneIdentifier = ''
    depthArray.map((depth, index) => {
        if(depth === 0){
            cloneIdentifier += splitIdentifier[index]+ '/'
        }else{
            cloneIdentifier += splitIdentifier[index]+ '|'+depth+'/'
        }
      
    })
    if(splitIdentifier.length === depthArray.length){
      identifier = cloneIdentifier.slice(0, -1); 
    }else{
        identifier = cloneIdentifier + splitIdentifier[splitIdentifier.length-1]
    }
  }else if (!field.maxOccurs && field.children){
      identifier = identifier + '|' + depthArray[0]
  }
  return identifier
}
  
/* 
  This function together with mergeIndexes() replicates the behaviour of the addGroup function in RepeatGroup.js
  Genereates field identifiers with suffixes for Groups
  Here the depthArray keeps track of the suffixes that would be replaced in the identifier

  Example: depthArray = [1] for identifier: Group/Image_Question => Group|1/Image_Question
*/
export const createFieldsWithIndexes = (fields) => {
    let depthArray = [0]
    let associativeArray = {}
    const clonedFields = fields.filter((field) => {
        if (field.type === "group") {
            if (field.identifier.includes("/")) {
                let elements = field.identifier.split("/").length
                //checking for more than 1 subgroup
                if (elements < depthArray.length) {
                    depthArray.length = elements
                }
                if (depthArray[elements - 1] === undefined || depthArray[elements - 1] == 0) {
                    if (field.maxOccurs) {
                        /* Whenever a Subgroup occurs, the 0 is added so that
                            it will be checked in mergeIndexes()*/
                        depthArray[elements - 1] = 0
                    } else {
                        associativeArray[field.identifier] = 1
                        depthArray[elements - 1] = 1
                    }
                } else {
                    if (field.maxOccurs) {
                        depthArray[elements - 1] = 0
                    } else {
                        if (associativeArray.hasOwnProperty(field.identifier)) {
                            depthArray[elements - 1] = depthArray[elements - 1] + 1
                            associativeArray[field.identifier] += 1
                        } else {
                            associativeArray[field.identifier] = 1
                            depthArray[elements - 1] = 1
                        }

                    }
                }
                field.identifier = mergeIndexes(field, depthArray)
                return field
            } else if (!field.maxOccurs) {
                /* Added the check because Subgroups identifiers do not take Suffixes
                    So enters here only for Groups*/
                if (associativeArray.hasOwnProperty(field.identifier)) {
                    depthArray[0] = depthArray[0] + 1
                    associativeArray[field.identifier] += 1
                } else {
                    associativeArray[field.identifier] = 1
                    depthArray[0] = 1
                }
                depthArray.length = 1
                field.identifier = mergeIndexes(field, depthArray)
                return field
            }
        }
        if (field.maxOccurs) {
            for (let i = 0; i < depthArray.length; i++) {
                depthArray[i] = 0
            }
        }

        if (field.identifier.split('/').length <= depthArray.length) {
            const cloneDepthArray = JSON.parse(JSON.stringify(depthArray))
            cloneDepthArray.length = field.identifier.split('/').length - 1
            field.identifier = mergeIndexes(field, cloneDepthArray)
            return field;
        }

        field.identifier = mergeIndexes(field, depthArray)
        return field
    })

    return clonedFields
}


export const createFieldsWithIndexesForDispatch = (fields) => {
    let depthArray = [0]
    let associativeArray = {}
    const clonedFields = fields.filter((field) => {
        if (field.type === "group") {
            if (field.identifier.includes("/")) {
                let elements = field.identifier.split("/").length
                //checking for more than 1 subgroup
                if (elements < depthArray.length) {
                    depthArray.length = elements
                }
                if (depthArray[elements - 1] === undefined || depthArray[elements - 1] == 0) {
                    if (field.maxOccurs) {
                        /* Whenever a Subgroup occurs, the 0 is added so that
                            it will be checked in mergeIndexes()*/
                        depthArray[elements - 1] = 0
                    } else {
                        associativeArray[field.identifier] = 1
                        depthArray[elements - 1] = 1
                    }
                } else {
                    if (field.maxOccurs) {
                        depthArray[elements - 1] = 0
                    } else {
                        if (associativeArray.hasOwnProperty(field.identifier)) {
                            depthArray[elements - 1] = depthArray[elements - 1] + 1
                            associativeArray[field.identifier] += 1
                        } else {
                            associativeArray[field.identifier] = 1
                            depthArray[elements - 1] = 1
                        }

                    }
                }
                field.identifier = mergeIndexes(field, depthArray)
                return field
            } else if (!field.maxOccurs) {
                /* Added the check because Subgroups identifiers do not take Suffixes
                    So enters here only for Groups*/
                if (associativeArray.hasOwnProperty(field.identifier)) {
                    depthArray[0] = depthArray[0] + 1
                    associativeArray[field.identifier] += 1
                } else {
                    associativeArray[field.identifier] = 1
                    depthArray[0] = 1
                }
                depthArray.length = 1
                field.identifier = mergeIndexes(field, depthArray)
                return field
            }
        }

        if (field.maxOccurs) {
            for (let i = 0; i < depthArray.length; i++) {
                depthArray[i] = 0
            }
        }

        if (field.identifier.split('/').length <= depthArray.length) {
            const cloneDepthArray = JSON.parse(JSON.stringify(depthArray))
            cloneDepthArray.length = field.identifier.split('/').length - 1
            field.identifier = mergeIndexes(field, cloneDepthArray)
            return field;
        }

        field.identifier = mergeIndexes(field, depthArray)
        return field
    })

    return clonedFields
}

export const createFieldNamesArray = (fields, fieldNamesArray = []) => {
  fields.forEach((field) => {
    if (field.children) {
      // eslint-disable-next-line no-param-reassign
      fieldNamesArray.push(field.identifier);
      fieldNamesArray = createFieldNamesArray(field.children, fieldNamesArray);
    } else {
      fieldNamesArray.push(field.identifier);
    }
  }, []);

  return fieldNamesArray;
};

/**
 * This function loops over all the fields and puts in an object only the ones that are involved in
 * some expression.
 * 
 * It returns the object fieldsToWatch which will have the following structure:
 *
{
  "Yes_No_Question": [{
    targetField: {
      identifier: "Free_Text_Question",
      type: "text",
      active_expr: "ISBLANK(Yes_No_Question, Select_Question)"
    },
    additionalFields: ['Yes_No_Question', 'Select_Question']
  }],
  "Select_Question": [{
    targetField: {
      identifier: "Free_Text_Question",
      type: "text",
      active_expr: "ISBLANK(Yes_No_Question, Select_Question)"
    },
    additionalFields: ['Yes_No_Question', 'Select_Question']
  }]
  
  - The key ("Yes_no_Question" or "Select_Question") is the identifier of the field that needs to be watched when their 
  value changes.
  - targetField: is the field object that has the function. This function will contain the key that is set in the object. 
  - additionalFields: is needed to get all the required values for the function. If the function contains more than 1 field, 
  then, this array will contain all of the identifiers involved in the function. 

  In this case "ISBLANK(Yes_No_Question, Select_Question)" function needs to watch "Yes_No_Question" and "Select_Question"
  that's why the map has those 2 keys. 
}
 * 
 * @param {Array[Object<Input>]} fields
 * @param {Array[String]} fieldNamesArray
 * @param {Map[String : Object]} fieldsToWatch
 */
export const lookAtFieldToWatchFromFormulas = (
  fields,
  fieldNamesArray = [],
  fieldsWithExpressions = {},
  fieldsToWatch = {}
) => {
  fields.forEach((field) => {
    if (field.children) {
      lookAtFieldToWatchFromFormulas(
        field.children,
        fieldNamesArray,
        fieldsWithExpressions,
        fieldsToWatch
      );
    }
    //Removing children from field object so that redux store doesn't get too big
    let { children, ...fieldWithoutChildren } = field;
    const formulas = [];
    for (let i = 0; i < expressionNames.length; i++) {
      if (field[expressionNames[i]]) {
        formulas.push(field[expressionNames[i]]);

        fieldsWithExpressions[field.identifier] = { targetField: fieldWithoutChildren };
      }
    }

    if (formulas.length > 0) {
      const targetFields = [];

      formulas.forEach((formula) => {
        const expressionFieldsList = getExpressionFields(formula);

        expressionFieldsList.forEach((expressionFieldWithSpaces) => {
          const expressionFieldName = expressionFieldWithSpaces.trim();

          if (fieldNamesArray.includes(expressionFieldName)) {
            targetFields.push(expressionFieldName);
          }
        });
      });

      if (targetFields.length > 0) {
        const targetAndAdditionalFields = {
          targetField: fieldWithoutChildren,
          additionalFields: targetFields,
        };

        fieldsWithExpressions[field.identifier] = targetAndAdditionalFields;

        for (let i = 0; i < targetFields.length; i++) {
          if (!fieldsToWatch[targetFields[i]]) {
            fieldsToWatch[targetFields[i]] = [targetAndAdditionalFields];
          } else {
            fieldsToWatch[targetFields[i]].push(targetAndAdditionalFields);
          }
        }
      }
    }
  });
  return { fieldsWithExpressions, fieldsToWatch };
};